module.exports = __webpack_public_path__ + "static/media/stat547u_pset01_template.4f1350ca.tex";